import "./styles.css";
const TextInput = ({id , value , onChange , type , label , classname = "" , ...rest})=> {
    return (
        <div className="card">
            <div className="card-body">
                {label && <label htmlFor={`${id}`} className="card-title mb-2">{label}</label>}
                <input id={id} type={`${!type ? "text" : type}`} className={`text-input form-control ${classname} ${type=="number" ? "ltr text-center" : ""}`} value={value ? value : ""} onWheel={ event => event.currentTarget.blur() } onChange={(event) => {onChange(event.target.value)} } {...rest} />
            </div>
        </div>
    );
}

export const TextInputWithoutContainer = ({id , value , onChange , type , label , classname = "" , ...rest})=> {
    return (
        <div>
            {label && <label htmlFor={`${id}`} className="card-title mb-2">{label}</label>}
            <input id={id} type={`${!type ? "text" : type}`} className={`text-input form-control ${classname} ${type=="number" ? "ltr text-center" : ""}`} value={value ? value : ""} onWheel={ event => event.currentTarget.blur() } onChange={(event) => {onChange(event.target.value)} } {...rest} />
        </div>
    );
}

export default TextInput;